import { Note } from './note.model';
import { KirokuSetting } from './record-settig.model';

interface BlData {
  bldata: string;
  id: string;
  ext: string;
  objkbn?: string;
  insdate: Date;
  updstfcd?: string;
  upddate: Date;
  delflg: boolean;
}

export interface RecordItem {
  noteblobs: any[];
  objkbn: string;
  objcd: string;
  noteid: number;
  sdate: Date;
  edate: Date;
  corpcd: string;
  officecd: string;
  blockcd: string;
  subcd: string;
  unitcd: string;
  ttlkbn: string;
  ttlcd: string;
  ttlnm: string;
  resultatr?: number;
  pickupflg?: number;
  v2contents: string;
  bldata?: BlData[];
  icon?: string;
  dockbn?: number
}

export interface RecordDetail extends RecordItem {
  objnm: string;
  notekbn: number;
  lifeflg?: number;
  delstat: number;
  ownstfcd: string;
  ownstfnm: string;
  ownunitcd: string;
  odrstfcd: string;
  odrstfnm: string;
  sndstfnm?: string;
}

export interface RecordField {
  objkbn: string;
  objcd: string;
  objnm: string;
  noteid?: number;
  sdate?: Date;
  edate?: Date;
  corpcd: string;
  officecd: string;
  blockcd: string;
  subcd: string;
  unitcd: string;
  ttlkbn: string;
  ttlcd: string;
  ttlnm: string;
  notekbn: number;
  resultatr?: number;
  pickupflg?: number;
  lifeflg?: number;
  delstat: number;
  ownstfcd: string;
  ownstfnm: string;
  ownunitcd: string;
  odrstfcd?: string;
  odrstfnm?: string;
  contents?: string;
  v2contents?: string;
  bldata?: BlData[];
  insdate?: Date;
  subject?: string;
}

export interface RecordTitleSet {
  ttlnm: string;
  titles: RecordTitle[];
}

export interface RecordTitle {
  corpcd: string;
  officecd: string;
  blockcd: string;
  subcd: string;
  unitcd: string;
  ttlkbn: string;
  ttlcd: string;
  ttlnm: string;
  objnm: string;
  ttltag?: string;
  dockbn?: number;
}

export interface MenuParam extends RecordListType {
  ckbnId: string | null;
  id: string | null;
  ctype?: string | null;
  action?: string | null;
  skip?: number | null;
}

export interface DisplaySetting extends ListEnvs {
  daicd: string[];
  staffCd: string[];
  sdate: Date | null;
  edate: Date | null;
  offsetPaging: number | null;
  keyword: string[];
  pickupflg: number;
  lifeflg: number;
  title: RecordTitle[];
}

export interface RecordList {
  note: Note;
  tagColor?: [number, number, number];
  displayOption?: {
    readable: boolean;
    writable: boolean;
    isLocked: boolean;
  };
}

export interface DBRecordList {
  groupId: string;
  list: RecordList[];
}

export interface RecordListResponse extends ListEnvs, RecordListPagingParam {
  displaySdate: Date | null;
  displayEdate: Date | null;
  record: RecordList[];
  takeRecord?: number;
  successRequest?: boolean;
  newLoad?: boolean;
}

export const NameLocalStorage = {
  DISPLAY_SETTING: 'displaySetting',
  CONDITION_FILTER: 'conditionFilter',
  BOARD_SELECTED: 'boardSelected',
  SCHEDULE_LIST: 'scheduleList',
  USER: 'user',
  CURRENT_STAFF_CODE: 'currentStaffCode',
  CURRENT_USER_CODE: 'currentUserCode',
  DISPLAY_SETTING_DATE: 'displaySettingDate',
  HITORIBUNNO: 'hitoribunno',
  SELECTED_TITLES: 'selectedTitles',
};

export interface ListEnvs {
  listEnvXML?: any;
  listEnv?: object | null;
}

export interface BaseTimeRecordListResponse {
  baseSTime: Date | null;
  baseETime: Date | null;
}

export interface RecordListType {
  type?: string | null;
}

export interface RecordListPagingParam {
  blockData?: number;
  fetchDateDone?: boolean;
}

export enum MENU_KIDS {
  AREDASITE = 'AREDASITE',
  JIBUNKATTE = 'JIBUNKATTE',
  KATTEGUAI = 'KATTEGUAI',
  KORU = 'KORU',
  AIGO = 'AIGO',
  CHOHYOU = 'CHOHYOU',
  KIROKU = 'KIROKU',
  HAISETSU = 'HAISETSU',
  ONDOBAN = 'ONDOBAN',
  ONDOBANICHIRAN = 'ONDOBANICHIRAN',
  JIBUNGAIRETA = 'JIBUNGAIRETA',
  HITORIBUNNO = 'HITORIBUNNO',
  CASEFILE = 'CASEFILE',
}

export enum KirokuMenu {
  EMPTY = '',
  MOUSHIOKURI = 'MOUSHIOKURI',
  KYOUNOKIROKU = 'KYOUNOKIROKU',
  GYOUMURENRAKU = 'GYOMURENRAKU',
  JIBUNGAIRETA = 'JIBUNGAIRETA',
  HITORIBUNNO = 'HITORIBUNNO',
  HAISETSUCHUUISHA = 'HAISETSUCHUUISHA',
  KYOUNOBAITARU = 'KYOUNOBAITARU',
  KYOUNOSHOKUJI = 'KYOUNOSHOKUJI',
  KYOUNOHAISETSU = 'KYOUNOHAISETSU',
  KYOUNONYUUYOKU = 'KYOUNONYUUYOKU',
  ONDOBAN = 'ONDOBAN',
  ONDOBANICHIRAN = 'ONDOBANICHIRAN',
  KIROKUKENSAKU = 'KIROKUKENSAKU',
  SHIENKEIKA = 'SHIENKEIKA',
  CASEFILE = 'CASEFILE',
}

export class NoteListConfig {
  type: KirokuMenu = KirokuMenu.MOUSHIOKURI;
  screenName: string = '';
  isMultipleUser: boolean = false;
  // by day
  initDaySpan: number = 1;
  // init title filter
  tags?: string[] = [];
  officeOnly?: boolean = false
}

export interface RecordListConfigPayload extends KirokuSetting {
  page: number,
  ttlnames?: string[],
  type?: string,
}

export interface RecordTagSet {
  ttlnm: string;
  ttl_kbntag: string;
  titles: RecordTitle[];
}